import { render, staticRenderFns } from "./FullWidthCTA.vue?vue&type=template&id=141685ef&scoped=true&"
import script from "./FullWidthCTA.vue?vue&type=script&lang=ts&"
export * from "./FullWidthCTA.vue?vue&type=script&lang=ts&"
import style0 from "./FullWidthCTA.vue?vue&type=style&index=0&id=141685ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141685ef",
  null
  
)

export default component.exports